<template>
  <div class="accordion_wrap all_mail_list">
    <template v-if="activityLogs.length > 0">
      <div v-for="(log, index) in activityLogs" class="accordion" :class="[index % 2 !== 0 ? 'color_grey_bg_type_2' : '']" :key="'log_'+index">
        <div class="accordion_heading">
          <div class="accordion_heading_inner" data-toggle="collapse_slide" :data-target="'#activityLog_'+log.id">
            <div class="reply_box_head_wrap">
              <div class="left">
                <div class="author info_bg">
                  <span>{{ getFirstCharacter(log?.actor?.name) }}</span>
                </div>
                <div class="content_details">
                  <p><b>{{ log?.actor?.name }} </b></p>
                  <p>{{ log.created_at }} </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion_body" :id="'activityLog_'+log.id">
<!--          <p> <b class="fw_500">To:</b><span class="mr_10">johndoe@gmail.com</span>  <b class="fw_500">Cc:</b><span>info@vlan24.com</span> </p>-->
          <p>{{ capitalizedStr(log.action) }}</p>
          <template v-if="log.action === 'created' && log.details">
            <p v-for="(value, key) in log.details" :key="key">
              <template v-if="key === 'request_from'">
                {{ formatString(key) }} - {{ value }}
              </template>
            </p>
          </template>
          <template v-else>
            <p v-for="(value, key) in log.details" :key="key">
              {{ formatString(key) }} - {{ value }}
            </p>
          </template>

        </div>
      </div>
<!--      <div class="accordion color_grey_bg_type_2">
        <div class="accordion_heading">
          <div class="accordion_heading_inner" data-toggle="collapse_slide" data-target="#Card11">
            <div class="reply_box_head_wrap">
              <div class="left">
                <div class="author info_bg">
                  <span>A</span>
                </div>
                <div class="content_details">
                  <p><b>Support </b> replied </p>
                  <p>May 9, 2024, 7:58 (3 days ago) </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion_body" id="Card11">
          <p> <b class="fw_500">To:</b><span class="mr_10">johndoe@gmail.com</span>  <b class="fw_500">Cc:</b><span>info@vlan24.com</span> </p>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque dolorem necessitatibus enim vitae architecto magnam rerum quaerat laboriosam, iure beatae, velit repudiandae animi minus nobis aliquid facere tenetur quasi harum officia. Cupiditate incidunt sequi eaque aperiam molestiae eius molestias sapiente quae. Cumque sed dolorum autem at assumenda porro sint reprehenderit itaque harum error ipsum odit voluptatem rem quaerat officiis deserunt, suscipit earum eius ab laboriosam doloribus provident omnis labore sit. Atque voluptatum ipsum aspernatur dolores ab. Id quis nam fugit neque, temporibus molestiae odit nobis iusto cum sint? Modi reiciendis sequi voluptates quis corrupti suscipit repudiandae sed inventore non esse.</p>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque dolorem necessitatibus enim vitae architecto magnam rerum quaerat laboriosam, iure beatae, velit repudiandae animi minus nobis aliquid facere tenetur quasi harum officia. Cupiditate incidunt sequi eaque aperiam molestiae eius molestias sapiente quae. Cumque sed dolorum autem at assumenda porro sint reprehenderit itaque harum error ipsum odit voluptatem rem quaerat officiis deserunt, suscipit earum eius ab laboriosam doloribus provident omnis labore sit. Atque voluptatum ipsum aspernatur dolores ab. Id quis nam fugit neque, temporibus molestiae odit nobis iusto cum sint? Modi reiciendis sequi voluptates quis corrupti suscipit repudiandae sed inventore non esse.</p>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque dolorem necessitatibus enim vitae architecto magnam rerum quaerat laboriosam, iure beatae, velit repudiandae animi minus nobis aliquid facere tenetur quasi harum officia. Cupiditate incidunt sequi eaque aperiam molestiae eius molestias sapiente quae. Cumque sed dolorum autem at assumenda porro sint reprehenderit itaque harum error ipsum odit voluptatem rem quaerat officiis deserunt, suscipit earum eius ab laboriosam doloribus provident omnis labore sit. Atque voluptatum ipsum aspernatur dolores ab. Id quis nam fugit neque, temporibus molestiae odit nobis iusto cum sint? Modi reiciendis sequi voluptates quis corrupti suscipit repudiandae sed inventore non esse.</p>
        </div>
      </div>-->
    </template>
    <template v-else>
      <p>No activity found!</p>
    </template>
  </div>
</template>
<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "TicketActivityLogs",
  data(){
    return {
      activityLogs: [],
      ticketNumber: this.$route.params.ticket_number
    }
  },
  mounted() {
    this.getTicketActivityLogs()
  },
  methods: {
    getTicketActivityLogs(){
      this.axios.get(`/ticket-activity-logs/${this.ticketNumber}`)
          .then(({ data }) => {
            this.activityLogs = data.data
          })
    },
    getFirstCharacter(name) {
      return name ? name.charAt(0) : '';
    },
    capitalizedStr(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    formatString(value) {
      let formattedString = value.replace(/_/g, ' ');
      formattedString = formattedString.charAt(0).toUpperCase() + formattedString.slice(1);
      return formattedString;
    }
  }
})
</script>
<style scoped>

</style>